import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/** Put all uiSchema options here, in the template they go under ui:options: */
export const DecisionCardUiOptionsSchema = z.object({
  autofocus: z.boolean().optional(),
});

/** Transforms the Zod schema to a TypeScript type */
export type DecisionCardUiOptions = z.infer<typeof DecisionCardUiOptionsSchema>;

/** The field schema for the DecisionCard field extension */
export const DecisionCardSchema = makeFieldSchemaFromZod(
  z.record(z.union([z.boolean(), z.string()])).describe('Decision Card'),
  DecisionCardUiOptionsSchema,
);

/** Transforms the field schema props to a TypeScript type */
export type DecisionCardProps = typeof DecisionCardSchema.type;

/** The final schema used for the field extension */
export const DecisionCardSchemaFinal = DecisionCardSchema.schema;
